export const MAX_CONSULTATION_NUMBER = 1000
export const MAX_NEGATIVATION_NUMBER = 1000

export const CONSULTATION_TYPES = [
  { value: 'cpf', label: 'Consultar CPF' },
  {
    value: 'cnpj',
    label: 'Consultar CNPJ'
  },
  { value: 'cpf_cnpj', label: 'Consultar CPF e CNPJ' }
]

export const REPORT_TYPES = [
  {
    value: 'basic',
    label: 'Relatório Básico',
    available_services: [
      'Score',
      'Dados cadastrais',
      'Dados restritivos',
      'Renda presumida',
      'Indicadores positivos',
      'Quadro societário',
      'Limite de crédito'
    ]
  },
  {
    value: 'intermediate',
    label: 'Relatório Intermediário',
    available_services: [
      'Score',
      'Dados cadastrais',
      'Dados restritivos',
      'Renda presumida',
      'Indicadores positivos',
      'Indicador de decisão',
      'Quadro societário'
    ]
  },
  {
    value: 'advanced',
    label: 'Relatório Completo',
    available_services: [
      'Score',
      'Dados cadastrais',
      'Dados restritivos',
      'Renda presumida',
      'Indicadores positivos',
      'Indicador de decisão',
      'Limite de parcela sugerida',
      'Quadro societário',
      'Limite de crédito'
    ]
  }
]
